module.exports = __webpack_public_path__ + "static/img/Thumbs.da9cb7a.db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/overlays/Thumbs.db
// module id = 677
// module chunks = 1